(function () {
  'use strict';

  function bindNav(nav) {
    var triggers = nav.querySelectorAll('.jj-footer__accordion-trigger');
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.jj-footer__accordion-item');
        if (!item) return;
        var isOpen = item.classList.contains('jj-footer__accordion-item--open');
        item.classList.toggle('jj-footer__accordion-item--open', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('.jj-footer__nav-accordion[data-section-id]').forEach(bindNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   JJ Footer — Klaviyo newsletter subscribe (single opt-in)
   Posts directly to Klaviyo's client subscribe endpoint so the
   profile lands as "Subscribed" with email consent (no limbo).
   ============================================================ */
(function () {
  function initKlaviyoForm(form) {
    if (form.dataset.jjKlaviyoInit === 'true') return;
    form.dataset.jjKlaviyoInit = 'true';

    var companyId = form.dataset.klaviyoCompanyId;
    var listId = form.dataset.klaviyoListId;
    var input = form.querySelector('.jj-footer__newsletter-input');
    var button = form.querySelector('[data-jj-klaviyo-submit]');
    var successEl = form.querySelector('.jj-footer__form-message--success');
    var errorEl = form.querySelector('.jj-footer__form-message--error');

    function showMessage(el, text) {
      if (successEl) { successEl.hidden = true; }
      if (errorEl) { errorEl.hidden = true; }
      if (el) { el.textContent = text; el.hidden = false; }
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function submit() {
      var email = (input.value || '').trim();

      if (!isValidEmail(email)) {
        showMessage(errorEl, 'Please enter a valid email address.');
        return;
      }

      button.disabled = true;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15'
          },
          body: JSON.stringify(payload)
        }
      )
        .then(function (res) {
          if (res.status === 202) {
            showMessage(successEl, 'Thanks — you’re subscribed.');
            input.value = '';
          } else {
            return res.json().then(function (data) {
              var detail =
                (data && data.errors && data.errors[0] && data.errors[0].detail) ||
                'Something went wrong. Please try again.';
              showMessage(errorEl, detail);
            });
          }
        })
        .catch(function () {
          showMessage(errorEl, 'Something went wrong. Please try again.');
        })
        .finally(function () {
          button.disabled = false;
        });
    }

    button.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-jj-klaviyo-form]')
      .forEach(initKlaviyoForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in the theme editor when the section reloads.
  document.addEventListener('shopify:section:load', initAll);
})();